<template>
  <div class="card-offered-item">
    <div class="d-flex justify-space-between">
      <v-btn
        class="button-delete-offered"
        icon
        @click="deleteOfferedItem()"
      >
        <v-icon color="ic_invalid">
          mdi-delete-outline
        </v-icon>
      </v-btn>

      <card-info
        :item="item.credit_offered"
        :show-year="true"
      />

      <div class="card-actions">
        <div class="card-content-actions text-right mr-8 d-flex flex-column justify-space-around">
          <div class="text-unit-value">
            {{ $t('components.card_cart.card_offered_item.unit_value') }}
          </div>
          <div class="text-unit-value">
            {{ $t('components.card_cart.card_offered_item.central_custody_fee_value') }}
          </div>
          <div class="text-total-value">
            {{ $t('components.card_cart.card_offered_item.total_value') }}
          </div>
        </div>

        <div class="card-content-actions d-flex flex-column justify-space-around">
          <div class="font-weight-bold">
            {{ formatMoney(item.credit_offered.unit_value_with_aditional) }}
          </div>
          <div class="font-weight-bold">
            {{ formatMoney(item.credit_offered.central_custody_fee_value) }}
          </div>
          <div class="font-weight-bold total-value">
            {{ formatMoney(totalValue) }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="budgetManagements.length > 0"
      class="d-flex justify-end budget-management"
    >
      <div class="budget-management-select">
        <v-autocomplete
          v-model="selectedBudgetManagement"
          :label="$t('components.card_cart.card_offered_item.budget_management')"
          :items="budgetManagements"
          item-text="name"
          item-value="id"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import formatMoney from '@/mixins/formatMoney';
import CardInfo from '@/components/cards/offered/CardInfo.vue';

export default {
  name: 'CardOfferedItem',
  components: {
    CardInfo,
  },
  mixins: [formatMoney],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    budgetManagements: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedBudgetManagement: null,
    };
  },
  computed: {
    ...mapGetters([
      'getBusiness',
      'getCreditOfferedBudgetById',
      'getCreditOfferedBudgetRelations',
    ]),

    totalValue() {
      return this.item.total_value;
    },
  },

  methods: {
    ...mapActions([
      'validateBudgetManagement',
      'addBudgetManagementToCreditOffered',
      'removeBudgetManagementFromCreditOffered',
    ]),

    deleteOfferedItem() {
      this.$emit('deleteOfferedItem', { index: this.index, id: this.item.id });
      this.removeBudgetManagementFromCreditOffered(this.item.credit_offered.id);
    },
  },

  watch: {
    selectedBudgetManagement(value) {
      if (value) {
        this.validateBudgetManagement({
          business_id: this.getBusiness.id,
          budget_management_id: value,
          credit_offered_id: this.item.credit_offered.id,
        }).then(() => {
          this.addBudgetManagementToCreditOffered({
            credit_offered_id: this.item.credit_offered.id,
            budget_management_id: value,
          });
        }).catch(() => {
          this.addBudgetManagementToCreditOffered({
            credit_offered_id: this.item.credit_offered.id,
            budget_management_id: null,
          });
          this.selectedBudgetManagement = null;
        });
      } else {
        this.addBudgetManagementToCreditOffered({
          credit_offered_id: this.item.credit_offered.id,
          budget_management_id: null,
        });
      }
    },
  },

  mounted() {
    const item = this.getCreditOfferedBudgetRelations.find((relation) => relation.credit_offered_id === this.item.credit_offered.id);
    this.selectedBudgetManagement = item?.budget_management_id;

    if (!item) {
      this.addBudgetManagementToCreditOffered({
        credit_offered_id: this.item.credit_offered.id,
        budget_management_id: this.item.budget_management_id,
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.card-offered-item {
  background: $card_offer;
  border-radius: 10px;
  padding: 20px;
  box-shadow: $box_shadow_cart_item;
  margin-bottom: 20px;
  position: relative;

  .button-delete-offered {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .card-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .card-content-actions {
      height: 200px;

      .text-quantity,
      .text-unit-value {
        font-size: 0.875em;
        color: $color_gray;
      }

      .text-quantity {
        height: 36px;
      }

      .text-total-value {
        font-size: 1em;
        color: $color_gray;
      }

      .total-value {
        font-size: 1.4em;
      }

      .field-quantity {
        background: $dashboard_background;
        width: 100%;
        max-width: 150px;
        border-radius: 10px;
        padding: 4px;
        text-align: center;
        outline: none;
      }
    }
  }
  .content-error {
    height: 10px;

    .error-message {
      color: $message_invalid;
      font-size: 0.8em;
      margin-top: 4px;
    }
  }

  .budget-management {
    margin-top: 20px;

    .budget-management-select {
      width: 400px;
    }
  }
}
</style>
